<app-template-design></app-template-design>
<p-confirmDialog [style]="{width: '35vw'}" [styleClass]="'alert-msg'" position="top"
  [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text">
</p-confirmDialog>
<p-toast position="top-right"></p-toast>